import { render, staticRenderFns } from "./fiscal-tab.vue?vue&type=template&id=5db6d2a5&"
import script from "./fiscal-tab.vue?vue&type=script&lang=js&"
export * from "./fiscal-tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports